import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {lang} from 'js/Core/lang';
const txtLang = lang.txt;
const mapStateToProps = state => {
  return {
    shopName: state.shop.name,
    shopTel: state.shop.tel,
    minTimeWorking: state.shop.minTimeWorking,
    maxTimeWorking: state.shop.maxTimeWorking,

  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}


class FooterClass extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {shopName,shopTel,minTimeWorking,maxTimeWorking} = this.props;
    return (
      <div   >
      <div className="attention_box mb30">
      <p className="mb00"><b>スマホ・携帯のメール受信設定について</b>
      迷惑メール対策などでPCメールの排除や受信ドメインの指定を行っている場合、こちらからの返信メールが受信できない場合があります。
      <span>お申込み前に「@sunnypoint.jp」の受信設定をお願いいたします。</span>      
      </p>
      </div>
      <div id="tel_box" className="tel_box">
            <p className="tel_ttl">{txtLang.support_by_phone}</p>
            <p className="tel_number">TEL：{shopTel} <span className='timeWorking'>({minTimeWorking}-{maxTimeWorking})</span></p>
      </div>
      </div>
    )
  }
}


export const Footer = connect(mapStateToProps, mapDispatchToProps)(FooterClass);